
export enum ResourceStatus {
    DRAFT = 0,
    PUBLISHED = 1,
    ARCHIVED = 2
}

export enum ResourceType {
    NOTE,
    MEDIA,
    FILE
}

export interface Resource {
    id: number
    title: string
    description: any
    status: ResourceStatus
    type: ResourceType
    url: string
    file: File | null
    classroom_id: number
    collection_id: number
    last_updated: string
    removed_resource: string
}
